'use client'
import {KennisCentrumHeader} from "./KennisCentumHeader";
import {KennisCentrumFilters} from "./KennisCentrumFilters";
import {ContentLijst} from "partials/support/Kenniscentrum/ContentLijst/ContentLijst";
import useKennisitems from "hooks/useKennisitems";
import {useSWRConfig} from 'swr'

export const KennisCentrum = ({searchParams, ingelogdeGebruiker}) => {
    const {kenniscentrumInitData} = useSWRConfig()
    const {cat, prod, typen, vid, taggroep, tekst, unlock, dash, inhoud, vers, kenmerk, fav} = searchParams;


    const {
        data,
        setSize,
        size,
        mutate,
        isLoading,
        isLoadingMore,
        isReachingEnd,
        total
    } = useKennisitems(ingelogdeGebruiker?.id, cat, prod, typen, vid, taggroep, tekst, unlock, dash, inhoud, vers, kenmerk, fav, kenniscentrumInitData)




    return <section key={Math.random()} style={{maxWidth: '1140px'}}
                    className={`container mx-auto flex-auto justify-center content-center`}>
        <section className="grid grid-cols-1 sm:grid-cols-12 gap-5 mt-4">
                <section className={`col-span-12`}>
                    <KennisCentrumHeader total={total}/>
                </section>


                <section className={`col-span-3`}>
                    <KennisCentrumFilters/>
                </section>


                <section className={`col-span-9`}>
                    <ContentLijst kennisItems={data} page={size} setSize={setSize} isLoadingMore={isLoadingMore}
                                  isLoading={isLoading} isReachingEnd={isReachingEnd} mutate={mutate}/>
                </section>
        </section>
    </section>
}